import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import { matchLocales } from '@vdi/walden-shared/utils';
import config from 'walden-fast/config/environment';

export default class NotFoundRoute extends Route {
  @service('intl') declare intlService: IntlService;

  model() {
    const matchedLocales = matchLocales({
      browserLocales: [...navigator.languages],
      supportedLocales: this.intlService.locales,
      defaultLocale: config.defaultLocale,
    });

    this.intlService.setLocale(
      window.localStorage.getItem('language') || matchedLocales,
    );
  }
}
